import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { concat } from 'lodash';
import { AllNavigationOptions, setImage } from '../../helper';
import noImage from '../../../assets/images/no-image.png';
import finerDetails from '../../../assets/images/finer_details.svg';
import { toasterMsg } from '../../Toaster/Toaster';

export function NavigationSetting({ obj, handleChangeByPath, handleImageUpload, allCustomSection, customSectionIndexs }) {
  const { t } = useTranslation('common');
  const getVal = obj?.anchorMenu?.map((vl) => vl.value);
  const [state, setState] = useState({ navigationOptions: AllNavigationOptions });
  const { navigationOptions } = state;
  console.log('allCustomSectionallCustomSection', allCustomSection?.length, customSectionIndexs);
  useEffect(() => {
    if (allCustomSection?.length) {
      const cloneCurrentNavigation = AllNavigationOptions;
      const updatedValuesofcustom = allCustomSection?.map((vl, ind) => {
        const getCustomCanvasIndex = customSectionIndexs[ind];
        return {
          label: vl?.title || 'Custom Section',
          displayLabel: 'custom section',
          value: `custom_section_${ind}`,
          defaultIcon: finerDetails,
          id: `finer-details-id-${getCustomCanvasIndex}`,
        };
      });
      const concatOPtiosn = concat(cloneCurrentNavigation, updatedValuesofcustom);
      setState((prev) => ({ ...prev, navigationOptions: concatOPtiosn }));
    }
  }, [allCustomSection?.length]);
  console.log('navigationOptionsnavigationOptions', navigationOptions);
  const validateSelectedNavigation = (val) => {
    if (val?.length <= 4) {
      handleChangeByPath(val, 'anchorMenu');
    } else {
      toasterMsg('You can select any four', 'danger');
    }
  };
  return (
    <>
      <FormGroup>
        <div className="common-react-select">
          <p className="field-name">{t('DPP.CONTROL.NAVIGATION.ANCHOR_MENU')}</p>
          <MultiSelect
            name="group"
            onChange={(val) => validateSelectedNavigation(val)}
            options={navigationOptions}
            className="product-custom-multiselect common-new-multiselect w-100"
            labelledBy={t('DPP.CONTROL.NAVIGATION.ANCHOR_MENU_PLACEHOLDER')}
            value={navigationOptions?.filter((vl) => getVal?.includes(vl.value))}
            overrideStrings={{
              selectSomeItems: t('DPP.CONTROL.NAVIGATION.ANCHOR_MENU_PLACEHOLDER'),
            }}
          />
        </div>
      </FormGroup>
      <div className="d-flex align-items-center">
        {obj?.anchorMenu?.map((vl, i) => {
          return (
            <div key={i} className="heading-icon-container mb-3 mr-16">
              <figure>
                <img src={vl?.defaultIcon ? setImage(vl?.defaultIcon) : noImage} alt="" />
              </figure>
              <button
                type="button"
                aria-label="Upload"
                className="btn d-inline-flex p-0"
                onClick={() => handleImageUpload('navigation', `${vl.value}_image_${i}`)}
              >
                <i className="icon icon-Upload-1 f-20" />
              </button>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default NavigationSetting;
